import React, { FC, useRef, useState } from "react"
import { Grid, Button, CircularProgress } from "@material-ui/core"

import { ChatMessageBuilder } from "@/components"
import { ChatMessageBuilderHandler, Message } from "@/components/ChatMessageBuilder"
import { Variable } from "@/components/ChatMessageBuilder/VariableInput"

import { BuildedMessage } from "@/protocols/messages"
import { formatChatMessageBuilderVariables } from "@/utils/formatChatMessageBuilderVariables"

import { ErrorType } from "@/hooks/useValidation"
import useDidMount from "@/hooks/useDidMount"

import ErrorHandler from "@/services/ErrorHandler"
import ApiService from "@/services/Api"

import useStyles from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/components/Messages/styles"
import { useGlobalStateStore } from "@/store/GlobalState"

type MessagesProps = {
	messages: BuildedMessage[],
	onSave: (messages: BuildedMessage[] | Message[]) => void | Promise<void>
}

const Messages: FC<MessagesProps> = (props) => {
	const {
		messages,
		onSave
	} = props

	const [loading, setLoading] = useState(false)
	const [snoozeVariables, setSnoozeVariables] = useState<Variable[]>([])
	const globalStateStore = useGlobalStateStore()
	const chatMessageBuilderRef = useRef<ChatMessageBuilderHandler>(null)
	const classes = useStyles()

	const handleSave = async () => {
		setLoading(true)

		const updatedMessages = chatMessageBuilderRef.current?.getMessages() || messages
		chatMessageBuilderRef.current?.blur()
		await onSave(updatedMessages)

		setLoading(false)
	}

	const handleGetAvailableVariables = async () => {
		try {
			const response = await ApiService.get("/snoozes/messages/variables", {
				params: {
					instanceId: globalStateStore.instance.instance_id
				}
			})

			const variables = formatChatMessageBuilderVariables(response.data)
			setSnoozeVariables(variables)
		} catch (error) {
			ErrorHandler.handle(error as ErrorType)
		}
	}

	useDidMount(() => {
		handleGetAvailableVariables()
	})

	return (
		<Grid container justifyContent="flex-end" spacing={2}>
			<Grid item xs={12}>
				<ChatMessageBuilder
					renderWithInitialMessage
					disabledInputs={["mentions", "custom-link", "ai-equivalent-variation"]}
					disabledMessage="Você não pode editar uma mensagem após o envio."
					ref={chatMessageBuilderRef}
					customClass={classes.chatMessageBuilderContainer}
					variables={snoozeVariables}
					isUniqueMessage
				/>
			</Grid>

			<Grid item>
				<Button
					variant="contained"
					color="primary"
					onClick={handleSave}
					endIcon={loading && <CircularProgress size={20} />}
					disabled={loading}
				>
						SALVAR
				</Button>
			</Grid>
		</Grid>
	)
}

export default Messages
